import {api} from '@/http'

// 归档列表
const getGDPGList = (data, callback, back) => {
  api('/api/GD_PG/List', 'post', data, callback, back)
}

// 归档
const archiveGD = (data, callback, back) => {
  api('/api/GD_PG/Examine', 'post', JSON.stringify(data), callback, back)
}

// 编号
const archiveBH = (data, callback, back) => {
  api('/api/GD_PG/SaveBuild', 'post', data, callback, back)
}

// 拆迁归档列表
const getGDCQList = (data, callback, back) => {
  api('/api/GD_CQ/List', 'post', data, callback, back)
}

// 完成
const archiveComplete = (id, callback, back) => {
  api('/api/GD_PG/Complete', 'post', {Id: id}, callback, back)
}

// 拆迁归档测算列表
const getGDCSList = (data, callback, back) => {
  api('/api/GD_CQ/CSList', 'post', data, callback, back)
}

// 拆迁测算归档
const archiveSubmit = (data, callback, back) => {
  api('/api/GD_CQ/Examine', 'post', JSON.stringify(data), callback, back)
}

export default {
  getGDPGList,
  archiveGD,
  archiveBH,
  getGDCQList,
  archiveComplete,
  getGDCSList,
  archiveSubmit
}



// WEBPACK FOOTER //
// ./src/api/archive/index.js